import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ConversationReports from 'dashboard/api/conversationReports';
import { downloadCsv } from 'dashboard/helper/commons';

export const state = {
  records: [],
  metrics: {
    totalCount: 0,
    messagesCount: 0,
    customerMessagesCount: 0,
    agentMessagesCount: 0,
    botMessagesCount: 0,
    tagCount: 0,
    dialogueTime: 0,
    humanDialogueTime: 0,
  },
};

export const getters = {
  //  获取会话记录
  getConversationReport(_state) {
    return _state.records;
  },
  // 获取会话记录头部汇总数据
  getConversationMetrics(_state) {
    return _state.metrics;
  },
};

export const actions = {
  get: async function getResponses(
    { commit },
    { page = 1, from, to, agents, channels, teams, startReason, endReason }
  ) {
    try {
      const response = await ConversationReports.get({
        page,
        from,
        to,
        agents,
        channels,
        teams,
        startReason,
        endReason,
      });
      commit(types.SET_CONVERSATION_REPORT_RESPONSE, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  getMetrics: async function getMetrics(
    { commit },
    { from, to, agents, channels, teams, startReason, endReason }
  ) {
    try {
      const response = await ConversationReports.getMetrics({
        from,
        to,
        agents,
        channels,
        teams,
        startReason,
        endReason,
      });
      commit(types.SET_CONVERSATION_RESPONSE_METRICS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetchingMetrics: false });
    }
  },
  downloadConversationsReports(_, reportObj) {
    return ConversationReports.downloadConversationsReports(reportObj)
      .then(response => {
        downloadCsv(response);
      })
      .catch(() => {
        // console.error(error);
      });
  },
};

export const mutations = {
  [types.SET_CONVERSATION_REPORT_RESPONSE]: MutationHelpers.set,
  [types.SET_CONVERSATION_RESPONSE_METRICS](
    _state,
    {
      total_count,
      messages_count,
      customer_messages_count,
      agent_messages_count,
      bot_messages_count,
      tag_count,
      dialogue_time,
      human_dialogue_time,
    }
  ) {
    _state.metrics.totalCount = total_count || 0;
    _state.metrics.messagesCount = messages_count || 0;
    _state.metrics.customerMessagesCount = customer_messages_count || 0;
    _state.metrics.agentMessagesCount = agent_messages_count || 0;
    _state.metrics.botMessagesCount = bot_messages_count || 0;
    _state.metrics.tagCount = tag_count || 0;
    _state.metrics.dialogueTime = dialogue_time || 0;
    _state.metrics.humanDialogueTime = human_dialogue_time || 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
